import { CLEAR_BUTTON_CLASSNAME } from "../InputControl/Input/InputBase.js";
const outlineBorderSelector = ":after", inputContainerStyles = ({
  disabledSelector,
  inputBodySelector,
  errorSelector,
  inputFocusedSelector,
  inputSelector
}) => (t) => ({
  boxSizing: "border-box",
  position: "relative",
  backgroundColor: t.palette.field.bg,
  [inputSelector]: {
    border: "none",
    height: "100%",
    boxSizing: "border-box",
    padding: "2px 12px",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: 500,
    color: t.palette.text.primary,
    outline: "none",
    // paddingInlineEnd: 30,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  [`&${errorSelector}${errorSelector}`]: {
    [inputBodySelector]: {
      [`&${outlineBorderSelector}`]: {
        ...border({
          width: 2,
          color: t.palette.field.regularbg.border.error,
          important: !0
        })
      }
    }
  },
  [inputBodySelector]: {
    [`&${outlineBorderSelector}`]: {
      content: '" "',
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "transparent",
      border: `1px solid ${t.palette.field.regularbg.border.default}`
    },
    boxSizing: "border-box",
    height: "100%",
    maxWidth: "100%"
  },
  [`${inputBodySelector}:focus-within, ${inputFocusedSelector}`]: {
    [`&${outlineBorderSelector}`]: {
      ...border({
        color: t.palette.field.regularbg.border.active,
        important: !0,
        width: 2
      })
    },
    [`.${CLEAR_BUTTON_CLASSNAME}`]: {
      visibility: "visible"
    }
  },
  [`&${disabledSelector}`]: {
    pointerEvents: "none",
    backgroundColor: t.palette.field.regularbg.bg.disabled,
    [inputBodySelector]: {
      [`&${outlineBorderSelector}`]: {
        ...border({ color: t.palette.field.regularbg.border.disabled })
      }
    },
    [inputSelector]: {
      backgroundColor: "transparent",
      color: `${t.palette.text.disabled}!important`
    }
  },
  "@media (hover: hover)": {
    [`${inputBodySelector}:hover`]: {
      [`&${outlineBorderSelector}`]: {
        ...border({
          width: 1,
          color: t.palette.field.regularbg.border.hover
        })
      }
    }
  }
}), border = ({
  color,
  width = 1,
  important
}) => ({
  border: `${width}px solid ${color}${important ? "!important" : ""}`
});
export {
  inputContainerStyles
};
//# sourceMappingURL=styles.js.map
